import { DefaultSmallButton } from '../Buttons/styles';
import {
  FormTemplateContainer,
  FormTemplateHeader,
  FormTemplateHeaderTitle,
  FormTemplateHeaderStep,
  FormTemplateHeaderInfo,
  FormTemplateContent
} from './styles';
import AlertaValidacionIdentidad from '../AlertaValidacionIdentidad';



const FormTemplate = ({ children, actionHeaderButton, idForm, idButton, labelButton, activeStep, stepLabel,idCredito }) => {
  return (
    <FormTemplateContainer id={idForm}>
      <FormTemplateHeader>
        <FormTemplateHeaderTitle>
          <FormTemplateHeaderStep>Paso {activeStep}</FormTemplateHeaderStep>
          <FormTemplateHeaderInfo>{stepLabel}</FormTemplateHeaderInfo>
        </FormTemplateHeaderTitle>
        {actionHeaderButton && (
          <DefaultSmallButton onClick={() => actionHeaderButton(true)} id={idButton}>{labelButton}</DefaultSmallButton>
        )}
        <AlertaValidacionIdentidad idCredito={idCredito}/>
      </FormTemplateHeader>
      <FormTemplateContent>
        {children}
      </FormTemplateContent>
    </FormTemplateContainer>
  )
}

export default FormTemplate;
